import React from "react";
import { useAppSelector } from "../../../../store";
import { formatCurrency } from "../../../../utils/formatting";
import { calculateBridgeStats } from "../../../../utils/calculations/bridgeCalculations";

export const BridgeSummary: React.FC = () => {
  const bridge = useAppSelector((state) => state.shipBuilder.bridge);
  const shipSize = useAppSelector((state) => state.shipBuilder.shipSize);

  // Calculate bridge stats using the calculation utility
  const bridgeStats =
    bridge && shipSize ? calculateBridgeStats(bridge, shipSize) : null;

  const bridgeCost =
    bridgeStats?.success && bridgeStats.data ? bridgeStats.data.cost : 0;
  const bridgeTons =
    bridgeStats?.success && bridgeStats.data ? bridgeStats.data.tons : 0;
  const bridgePower =
    bridgeStats?.success && bridgeStats.data ? bridgeStats.data.power : 0;
  const maintenanceCost =
    bridgeStats?.success && bridgeStats.data
      ? bridgeStats.data.maintenanceCost
      : 0;

  // Get bridge type description for display
  const getBridgeTypeDescription = () => {
    if (!bridge) return "No Bridge Selected";

    switch (bridge.type) {
      case "STANDARD":
        return "Standard Bridge";
      case "SMALLER":
        return "Smaller Bridge";
      case "COMMAND":
        return "Command Bridge";
      case "COCKPIT":
        return "Single Cockpit";
      case "DUAL_COCKPIT":
        return "Dual Cockpit";
      default:
        return "Unknown Bridge Type";
    }
  };

  return (
    <div className="bg-gray-800 text-white p-4 shadow-lg">
      <div className="container mx-auto grid grid-cols-[1fr_auto_auto] gap-x-12 items-center">
        {/* Details Row */}
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
          <div>
            <span className="text-gray-400 block">Bridge Type</span>
            <span className="font-semibold">{getBridgeTypeDescription()}</span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Base Cost</span>
            <span className="font-semibold">{formatCurrency(bridgeCost)}</span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Monthly Maintenance</span>
            <span className="font-semibold">
              {formatCurrency(maintenanceCost)}
            </span>
          </div>
          <div className="text-gray-400">|</div>
          <div>
            <span className="text-gray-400 block">Bridge Size</span>
            <span className="font-semibold">{bridgeTons.toFixed(1)} tons</span>
          </div>
        </div>

        {/* Total Cost */}
        <div className="text-right">
          <span className="text-gray-400 block text-sm">Total Bridge Cost</span>
          <span className="text-xl font-bold text-green-400">
            {formatCurrency(bridgeCost)}
          </span>
        </div>

        {/* Power Required */}
        <div className="flex flex-col items-center justify-center border-l border-r border-gray-700 px-8">
          <span className="text-gray-400 block text-sm">Power Required</span>
          <span className="text-3xl font-bold text-yellow-400">
            {bridgePower.toFixed(0)} Power
          </span>
        </div>
      </div>
    </div>
  );
};
